export const ARTICLES = 'articles';
export const ARTICLE = 'article';



// WEBPACK FOOTER //
// src/store/modules/blog/mutation-types.js